import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/stores/auth-store";
import {
  CONTEST_ONLY_HOME,
  isContestOnlyAdmin,
} from "@/config/contest-only-admins";

/**
 * 로그인 후 기본 진입 경로. 공모전 전용 계정은 공모전 페이지로,
 * 일반 어드민은 구독 관리로 보낸다. (사이드바 필터와 짝을 맞춰
 * "탭에 없는 페이지"가 첫 화면으로 뜨는 어색함을 없앤다.)
 */
export function DefaultRedirect() {
  const email = useAuthStore((s) => s.adminUser?.email);
  const to = isContestOnlyAdmin(email) ? CONTEST_ONLY_HOME : "/subscriptions";
  return <Navigate to={to} replace />;
}
